module.exports = __webpack_public_path__ + "img/es-ct.2404138b.svg";